module.exports = __webpack_public_path__ + "img/1543433086.deff7cd7.jpg";